export const SEARCH_DATA_ATTRIBUTE_IDS = {
  Buttons: {
    ClearFilters: 'SupplierDatabase.Search.Buttons.ClearFilters',
    ResultSearch: 'SupplierDatabase.Search.Buttons.ResultSearch',
    LandingSearch: 'SupplierDatabase.Search.Buttons.LandingSearch'
  },
  Options: {
    ByProduct: 'SupplierDatabase.Search.Options.ByProduct',
    ByCompany: 'SupplierDatabase.Search.Options.ByCompany',
    BySupplier: 'SupplierDatabase.Search.Options.BySupplier',
    ByASIN: 'SupplierDatabase.Search.Options.ByASIN'
  }
}
